import { CommandType } from "../../../../common/services/cqs/CommandType";
import { SkogsvardTradslagPlantaBaseCommand } from "./SkogsvardTradslagPlantaBaseCommand";

export class CreateSkogsvardTradslagPlantaCommand extends SkogsvardTradslagPlantaBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateSkogsvardTradslagPlantaCommand";

    constructor(atgardGuid: string, guid: string) {
        super(atgardGuid, guid, CreateSkogsvardTradslagPlantaCommand.$type, CommandType.Insert);
    }
}
